export default __webpack_public_path__ + "static/media/uploader-ascensiaContourNextMeter-problem-1.72a42ef9.png";